import * as React from "react";
import type { SVGProps } from "react";
const SvgCompare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      d="M8.722 8.562c.058 0 .113.022.155.062l.747.762c.23.286.515.522.837.693.323.17.676.273 1.038.3h1.069l-.777-.786a.246.246 0 0 1 0-.328.23.23 0 0 1 .317 0l1.16 1.163a.23.23 0 0 1 0 .323l-1.16 1.182a.2.2 0 0 1-.155.067.217.217 0 0 1-.161-.067.24.24 0 0 1 0-.323l.776-.792h-1.063a3 3 0 0 1-1.223-.336 3.1 3.1 0 0 1-.987-.81l-.728-.725a.24.24 0 0 1 0-.323.23.23 0 0 1 .155-.062M11.95 4c.059 0 .116.024.158.066l1.16 1.189a.23.23 0 0 1 0 .323l-1.16 1.176a.2.2 0 0 1-.155.067.217.217 0 0 1-.161-.067.241.241 0 0 1 0-.323l.776-.792h-1.069a2.6 2.6 0 0 0-1.025.292 2.7 2.7 0 0 0-.832.676C9.6 6.65 7.163 9.087 6.4 9.922a2.7 2.7 0 0 1-.884.632 2.7 2.7 0 0 1-1.056.227H2.894a.22.22 0 0 1-.16-.063.23.23 0 0 1-.067-.162c0-.061.024-.12.066-.163a.23.23 0 0 1 .161-.069h1.492c.314.01.627-.049.917-.172s.553-.307.768-.54c.774-.833 3.2-3.291 3.242-3.303.268-.333.601-.604.977-.798a3 3 0 0 1 1.21-.33h1.068l-.777-.791a.23.23 0 0 1 0-.324A.22.22 0 0 1 11.95 4M4.386 5.236c.376-.006.749.066 1.095.214s.66.368.918.646c.215.231.555.585.937.981a.226.226 0 0 1 0 .322.23.23 0 0 1-.155.068.23.23 0 0 1-.161-.068 26 26 0 0 1-.95-.993 2.3 2.3 0 0 0-.768-.537 2.2 2.2 0 0 0-.916-.176H2.894a.2.2 0 0 1-.087-.014.228.228 0 0 1-.14-.21c0-.062.024-.121.066-.164a.23.23 0 0 1 .161-.069z"
    />
  </svg>
);
export default SvgCompare;
